import { Outlet, ScrollRestoration } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ChatWidget from '@/components/ChatWidget';

export default function Layout() {
  return (
    <div className="flex flex-col min-h-screen bg-white font-sans text-slate-800">
      {/*
        Atalho para pular a navegação. Invisível até receber foco pelo teclado.
        Sem ele, quem navega por teclado ou leitor de tela precisa passar por
        todo o cabeçalho em cada página — e o cabeçalho tem 8 links mais o
        carrinho.
      */}
      <a
        href="#conteudo"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[200] focus:rounded-lg focus:bg-santa-dark focus:px-5 focus:py-3 focus:text-white focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-santa-gold"
      >
        Pular para o conteúdo
      </a>

      <Header />

      <main id="conteudo" className="flex-grow" tabIndex={-1}>
        <Outlet />
      </main>

      <Footer />

      {/*
        Restaura a posição de rolagem na navegação.
        Antes disso, ir de /exames para a ficha de um exame mantinha o scroll no
        meio da página anterior — o visitante caía no meio do texto e achava que
        a página tinha carregado errado.

        A chave é a rota inteira, incluindo os parâmetros de busca, para que
        voltar do detalhe do exame recupere a posição na listagem filtrada.
      */}
      <ScrollRestoration
        getKey={(location) => `${location.pathname}${location.search}`}
      />

      {/*
        Chat do site. Fica AQUI, dentro do Layout, e não no index.html — a
        posição é a metade da proteção.

        O comprovante (/pedido/:token/voucher) e o painel (/admin) são montados
        fora do Layout, então nem chegam perto deste componente. A outra metade
        é a lista de rotas em `@/lib/chat`, que também bloqueia /pedido/:token
        — essa sim mora dentro do Layout.

        Duas defesas para a mesma coisa porque o vazamento seria silencioso: o
        widget manda a URL inteira junto de cada mensagem, e /pedido/<token>
        tem o segredo do pedido na URL.
      */}
      <ChatWidget />
    </div>
  );
}
